import { render } from "./ViewPopup.vue?vue&type=template&id=5c477f4a&scoped=true"
import script from "./ViewPopup.vue?vue&type=script&lang=js"
export * from "./ViewPopup.vue?vue&type=script&lang=js"

import "./ViewPopup.vue?vue&type=style&index=0&id=5c477f4a&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c477f4a"]])

export default __exports__